import en from "commonAssets/i18n/en";

en['confirmation_page'] = {
    title: "Your Payment Form has been submitted successfully.",
    upload_fail: "",
    print_note: "Please print this page for your records.",
    claim_details: {
        title: "Your Payment Details",
        body: "PAYMENT INFORMATION",
        footer: '<p class="text-center fs-6">If you have any questions regarding your Payment, please provide the Submitted Correlation ID listed above when contacting the Settlement Administrator.</p>',
        edit: "",
    }
};
en['confirmation_this_is_a_copy'] = "THIS IS A COPY OF YOUR PAYMENT FORM";
en['confirmation_screen_additional'] = {
    title: "Notice",
    body: '<p class="fw-bold">You will receive a confirmation and copy of your payment election via email, including your Submitted Payment ID and Confirmation Code. Do not share your Payment ID or Confirmation Code with others. We will never call you for this information.</p><p>You may also print this screen for your records.</p><p>If you don\'t receive a confirmation email after 3 days, please check your spam filter.</p>',
};
en['claim_form_errors'] = "There are errors on the Payment Form.";

export default { en };
